(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/grassroots-shared/assets/javascripts/models/replace-receiver.js') >= 0) return;  svs.modules.push('/modules/grassroots-shared/assets/javascripts/models/replace-receiver.js');

(function(Backbone, _, svs) {
  'use strict';
  svs.grassroots.models.ReplaceReceiver = Backbone.Model.extend({
    replaceSupport: function(
      receiverToAddId,
      receiverToRemoveId,
      receiverToAddName
    ) {
      var self = this;
      var options = {
        method: 'PUT',
        path: '/player/1/sponsorship/receiverselection',
        data: {
          receiverToAdd: receiverToAddId,
          receiverToRemove: receiverToRemoveId
        }
      };
      options.data.omsKey = svs.grassroots.helpers.getOmsKey();
      svs.ui.loader.show();
      svs.core.jupiter.call(
        options,
        function(response) {
          svs.ui.loader.hide();
          svs.grassroots.helpers.dialog.infoToaster({
            title: 'Tack',
            message: `Nu stödjer du ${receiverToAddName}.`
          });
          self.collection.removeFromList(receiverToRemoveId, 'myReceiver');
          self.collection.addList(response.receivers, 'myReceiver');
          var evt = {
            category: 'Gräsroten',
            action: 'Ge mitt stöd',
            opt_label: receiverToAddName
          };
          svs.components.analytics.trackEvent(evt);
        },
        function(err) {
          svs.ui.loader.hide();
          var error = JSON.parse(err.responseText).error;
          switch (error.code) {
            case 10004: 
              svs.grassroots_logger.debug(
                'Set support for receiver error',
                svs.core.jupiter.parseErrorResponse(err)
              );
              svs.grassroots.helpers.dialog.errorToaster({
                title: 'Fel',
                message: `Du stödjer redan ${receiverToAddName}.`
              });
              break;
            default:
              svs.grassroots_logger.info(
                'Replace support for receiver error',
                svs.core.jupiter.parseErrorResponse(err)
              );

              svs.grassroots.helpers.dialog.errorPopup({
                title: 'Fel',
                message: `Kunde inte spara stöd till ${receiverToAddName}. Försök igen senare.`
              });
          }
        }
      );
    }
  });
})(Backbone, _, svs);


 })(window);